module.exports = __webpack_public_path__ + "static/media/cisa_logo_verbose.7722ba25.png";